<template>
  <v-app>
    <dashboard-core-app-bar v-model="expandOnHover" />

    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

    <dashboard-core-view class="dashboard-view" />
    <!-- <bottom-nav v-show="isMobile" /> -->

    <!--<dashboard-core-settings v-model="expandOnHover" />-->
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      // DashboardCoreSettings: () => import('./components/core/Settings'),
      // BottomNav: () => import('./components/core/BottomNav'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    created () {
      this.$vuetify.theme.dark = false
    },
  }
</script>
